<template>
  <div class="layout-container">
    <!-- 登录页面不显示头部和底部 -->
    <BaseHeader v-if="route.path !== '/login'" />

    <!-- 中间内容区 -->
    <main
      class="main-content"
      :class="{
        'no-padding': route.path === '/login',
        'full-width':
          route.path === '/audio-course-generator' ||
          route.path === '/audio-course-generate' ||
          route.path === '/audio-course-history',
      }"
    >
      <router-view />
    </main>

    <!-- 登录页面不显示头部和底部 -->
    <BaseFooter v-if="route.path !== '/login'" />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import BaseHeader from "./BaseHeader.vue";
import BaseFooter from "./BaseFooter.vue";

const route = useRoute();
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.main-content {
  flex: 1;
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.main-content.full-width {
  max-width: none;
  margin: 0;
  padding: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    padding: 10px;
  }
}
</style>
